import React from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient, antdModifiedTheme } from '@src/routers/constants';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ConfigProvider } from 'antd';
import { BrowserRouter } from 'react-router-dom';
import store from '@src/store';
import { Provider as ReduxProvider } from 'react-redux';
const { baseUrl } = window.conviva;
const ProviderWrapper: React.FC<any> = ({ children, isWidget }) => {
  return (
    <ReduxProvider store={store}>
      <QueryClientProvider client={queryClient}>
        <ReactQueryDevtools initialIsOpen={false} />
        <ConfigProvider
          theme={antdModifiedTheme}
          prefixCls="emp-ant"
          // mount within the app space for dark mode
          getPopupContainer={(): any => document.getElementById('emp-portals')}
        >
          <BrowserRouter
            future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
            basename={isWidget ? undefined : baseUrl}
          >
            {children}
          </BrowserRouter>
        </ConfigProvider>
      </QueryClientProvider>
    </ReduxProvider>
  );
};

export default ProviderWrapper;
